import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Footer Top Section */}
        <div className="footer-top">
          {/* Company Info */}
          <div className="footer-section">
            <h3 className="footer-heading">Safal India Automobile</h3>
            <p className="footer-description">
              Drive Smart. Drive Electric. Drive Grevol with Safal India.
              High-performance L5 EVs with intelligent thermal-managed lithium power.
              Easy finance, certified service, total peace of mind.
            </p>
            <div className="social-links">
              <a href="https://www.facebook.com/share/14YCEPyeB8n/" className="social-icon facebook" aria-label="Facebook" title="Facebook">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true" focusable="false">
                  <path d="M22 12c0-5.52-4.48-10-10-10S2 6.48 2 12c0 5 3.66 9.13 8.44 9.88v-6.99H7.9v-2.89h2.54V9.41c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.45h-1.25c-1.23 0-1.61.77-1.61 1.56v1.87h2.74l-.44 2.89h-2.3V21.9C18.34 21.13 22 17 22 12z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/grevolindia?igsh=b3Bsb2k2MmpwamZ4" className="social-icon instagram" aria-label="Instagram" title="Instagram">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="currentColor" aria-hidden="true" focusable="false">
                  <path d="M7 2h10a5 5 0 015 5v10a5 5 0 01-5 5H7a5 5 0 01-5-5V7a5 5 0 015-5zm5 6.5A4.5 4.5 0 1016.5 13 4.5 4.5 0 0012 8.5zm4.7-3.6a1.1 1.1 0 11-1.1 1.1 1.1 1.1 0 011.1-1.1z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-subheading">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#contact-form">Contact</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-subheading">Get In Touch</h4>
            <ul className="footer-contact">
              <li>
                <span className="contact-label">Email:</span>
                <a href="mailto:hello@safalauto.com">hello@safalauto.com</a>
              </li>
              <li>
                <span className="contact-label">Phone:</span>
                <a href="tel:+917870517720">+91 7870517720</a>
              </li>
              <li>
                <span className="contact-label">Address:</span>
                <span>Near Raja Naharsingh Metro Station, Pillar No. 1011
                  In The Premises of Jhilmil Dhabha, Ballabhgarh Faridabad</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom Section */}
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {currentYear} Safal Bharat. All rights reserved.</p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
